import { currencies } from "../config/currencies"

const findCurrencySymbol = currency => {
    return currencies.find(c => c.id === currency)?.symbol
}

export { findCurrencySymbol }
